export const colorBox = {
    financeIncome: [{
        moduleType: 'CnyCurrentMonthIncomeNoTax',
        title: '当月服务费收入不含税/当年服务费收入不含税',
        backgroundImage: 's3',
        unit: '万',
        showCompare: true,
        toType: 'CnyCurrentMonthIncomeNoTax',
    }, {
        moduleType: 'CurrentMonthInvoice',
        title: '当月(实际)开票额不含税/当年(实际)开票额不含税',
        backgroundImage: 'o3',
        unit: '万',
        showCompare: true,
        toType: 'CurrentMonthInvoice',
    }, {
        moduleType: 'CurrentMonthExpectedInvoiceByPercent',
        title: '当月预计开票额(不含税)-按进度计算',
        backgroundImage: 's1',
        unit: '万',
        showCompare: false,
        toType: 'CurrentMonthInvoice',
    }, {
        moduleType: 'CurrentMonthExpectedInvoiceByRemittance',
        title: '当月预计开票额(不含税)-按请款记录计算',
        backgroundImage: 'e1',
        unit: '万',
        showCompare: false,
        toType: 'CurrentMonthInvoice',
    }, {
        moduleType: 'CnySupplementCurrentMonthIncome',
        title: '补充合同当月收入不含税/补充合同当年收入不含税',
        backgroundImage: 's1',
        unit: '万',
        showCompare: true,
        toType: 'CnySupplementCurrentMonthIncome',
    }, {
        moduleType: 'MonthNewContractNum',
        title: '当月新增合同数/当年新增合同数',
        backgroundImage: 's7',
        unit: '',
        showCompare: true,
        toType: 'MonthNewContractNum',
    }, {
        moduleType: 'MonthNewContractAmount',
        title: '当月新增合同金额/当年新增合同金额',
        backgroundImage: 'e2',
        unit: '万',
        showCompare: true,
        toType: 'MonthNewContractNum',
    }, {
        moduleType: 'MonthWorkInAdvanceNum',
        title: '当月提前上岗合同数/当年提前上岗合同数',
        backgroundImage: 's4',
        unit: '',
        showCompare: true,
        toType: 'MonthWorkInAdvanceNum',
    }, {
        moduleType: 'MonthWorkInAdvanceAmount',
        title: '当月提前上岗合同金额/当年提前上岗合同金额',
        backgroundImage: 's2',
        unit: '万',
        showCompare: true,
        toType: 'MonthWorkInAdvanceNum',
    }, {
        moduleType: 'NextMonthOrderInHandNoInvoice',
        title: '下月在手订单额不含税（按进度计算）-非开票收入项目',
        backgroundImage: 's4',
        unit: '万',
        showCompare: true,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandInvoice',
        title: '下月在手订单额不含税（按进度计算）-开票收入项目',
        backgroundImage: 'o4',
        unit: '万',
        showCompare: true,
        toType: 'NextMonthOrderInHandInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandExpectedInvoice',
        title: '下月预计开票额不含税（请款记录取值）-开票收入项目',
        backgroundImage: 'e1',
        unit: '万',
        showCompare: true,
        toType: 'NextMonthOrderInHandExpectedInvoice',
    }, {
        moduleType: 'YearOrderInHand',
        title: '当年未来月份在手订单额(不含税)',
        backgroundImage: 's6',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'AllOrderInHand',
        title: '所有未来月份在手订单额(不含税)',
        backgroundImage: 'o2',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'MonthWorkInAdvanceTotalAmount',
        title: '累计尚在提前上岗状态合同数/累计尚在提前上岗状态合同额',
        backgroundImage: 's6',
        secondUnit: '万',
        showCompare: false,
        toType: 'MonthWorkInAdvanceNum',
    }, {
        moduleType: 'MonthInvoiceFinishDeviationAmount',
        title: '截止当月累计开票进度和完工进度金额差异（不含税）',
        backgroundImage: 'o2',
        unit: '万',
        showCompare: false,
        toType: 'MonthInvoiceFinishDeviationAmount',
    }],
    centerIncome: [{
        moduleType: 'CnyCurrentMonthIncomeNoTax',
        title: '当月服务费收入不含税/当年服务费收入不含税',
        backgroundImage: 's1',
        unit: '万',
        showCompare: true,
        toType: 'CnyCurrentMonthIncomeNoTax',
    }, {
        moduleType: 'CurrentMonthInvoice',
        title: '当月(实际)开票额不含税/当年(实际)开票额不含税',
        backgroundImage: 's2',
        unit: '万',
        showCompare: true,
        toType: 'CurrentMonthInvoice',
    }, {
        moduleType: 'CnyCurrentMonthIncomeNoTaxByPerson',
        title: '当月人均收入不含税',
        backgroundImage: 's6',
        showCompare: true,
        toType: 'CnyCurrentMonthIncomeNoTaxByPerson',
    }, {
        moduleType: 'NextMonthOrderInHandNoInvoice',
        title: '下月在手订单额不含税（按进度计算）-非开票收入项目',
        backgroundImage: 's4',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandInvoice',
        title: '下月在手订单额不含税（按进度计算）-开票收入项目',
        backgroundImage: 'o4',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandExpectedInvoice',
        title: '下月预计开票额不含税（请款记录取值）-开票收入项目',
        backgroundImage: 's1',
        unit: '万',
        showCompare: true,
        toType: 'NextMonthOrderInHandExpectedInvoice',
    }, {
        moduleType: 'YearOrderInHand',
        title: '当年未来月份在手订单额(不含税)',
        backgroundImage: 's4',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'AllOrderInHand',
        title: '所有未来月份在手订单额(不含税)',
        backgroundImage: 's5',
        unit: '万',
        showCompare: false,
        toType: 'NextMonthOrderInHandNoInvoice',
    }],
    request: [{
        moduleType: 'RemittanceMilestoneCurrentMonthEstimatedAmount',
        title: '截止当月预计milestone可请款金额',
        backgroundImage: 's1',
        unit: '万',
        showCompare: true,
    }, {
        moduleType: 'RemittanceMilestoneCurrentYearEstimatedAmount',
        title: '截止当年预计milestone可请款金额',
        backgroundImage: 's8',
        unit: '万',
        showCompare: false,
    }, {
        moduleType: 'RemittanceMonthlyInvoiceAmount',
        title: '当月已开票金额/当年已开票金额',
        backgroundImage: 's4',
        unit: '万',
        showCompare: true,
    }, {
        moduleType: 'RemittanceMonthlyBaConfirmsAmount',
        title: '当月BA确认可请款金额',
        backgroundImage: 'o2',
        unit: '万',
        showCompare: true,
    }, {
        moduleType: 'RemittanceMonthlyBaRefundableAmount',
        title: '截止当月BA延时不可请款金额',
        backgroundImage: 's6',
        unit: '万',
        showCompare: true,
    }, {
        moduleType: 'RemittanceMonthlyBackAmount',
        title: '当月回款金额/当年回款金额',
        backgroundImage: 's7',
        unit: '万',
        showCompare: true,
    }, {
        moduleType: 'RemittanceMonthlyRecordedRevenueNoInvoiceAmount',
        title: '当月已记收入未开票金额',
        backgroundImage: 's3',
        unit: '万',
        showCompare: true,
    }],
};

export const chartBox = {
    financeIncome: [{
        moduleType: 'CnyCurrentMonthIncomeNoTax',
        title: '每月服务费收入不含税',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'CnyCurrentMonthIncomeNoTax'
    }, {
        moduleType: 'CurrentMonthInvoice',
        title: '每月开票收入不含税',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'CurrentMonthInvoice'
    }, {
        moduleType: 'CnySupplementCurrentMonthIncome',
        title: '每月补充合同收入不含税',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'CnySupplementCurrentMonthIncome'
    }, {
        moduleType: 'NextMonthOrderInHandNoInvoice',
        title: '每月在手订单额(不含税)-非开票项目',
        unit: '万元',
        chartTypes: ['line'],
        showCompare: true,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandInvoice',
        title: '每月在手订单额(不含税)-开票项目',
        unit: '万元',
        chartTypes: ['line'],
        showCompare: true,
        toType: 'NextMonthOrderInHandInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandExpectedInvoice',
        title: '每月预计开票额(不含税)-开票收入项目',
        unit: '万元',
        chartTypes: ['line'],
        showCompare: true,
        toType: 'NextMonthOrderInHandExpectedInvoice',
    }, {
        moduleType: 'MonthNewContractNum',
        title: '每月新增合同数',
        chartTypes: ['column', 'line'],
        unit: '',
        toType: 'MonthNewContractNum'
    }, {
        moduleType: 'MonthNewContractAmount',
        title: '每月新增合同金额',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'MonthNewContractNum'
    }, {
        moduleType: 'MonthWorkInAdvanceNum',
        title: '每月提前上岗合同数',
        chartTypes: ['column', 'line'],
        unit: '',
        toType: 'MonthWorkInAdvanceNum'
    }, {
        moduleType: 'MonthWorkInAdvanceAmount',
        title: '每月提前上岗合同金额',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'MonthWorkInAdvanceNum'
    }],
    centerIncome: [{
        moduleType: 'CnyCurrentMonthIncomeNoTax',
        title: '每月服务费收入不含税',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'CnyCurrentMonthIncomeNoTax'
    }, {
        moduleType: 'CurrentMonthInvoice',
        title: '每月开票收入金额',
        chartTypes: ['column', 'line'],
        unit: '万元',
        toType: 'CurrentMonthInvoice'
    }, {
        moduleType: 'NextMonthOrderInHandNoInvoice',
        title: '每月在手订单额(不含税)-非开票项目',
        unit: '万元',
        chartTypes: ['line'],
        showCompare: true,
        toType: 'NextMonthOrderInHandNoInvoice',
    }, {
        moduleType: 'NextMonthOrderInHandInvoice',
        title: '每月在手订单额(不含税)-开票项目',
        unit: '万元',
        chartTypes: ['line'],
        showCompare: true,
        toType: 'NextMonthOrderInHandInvoice',
    }, {
        moduleType: 'CnyCurrentMonthIncomeNoTaxByPerson',
        title: '每月人均收入不含税',
        chartTypes: ['line'],
        unit: '元',
        toType: 'CnyCurrentMonthIncomeNoTaxByPerson'
    }, {
        moduleType: 'NextMonthOrderInHandExpectedInvoice',
        title: '每月预计开票额(不含税)-开票收入项目',
        chartTypes: ['line'],
        unit: '万元',
        toType: 'NextMonthOrderInHandExpectedInvoice',
    }],
    request: [{
        moduleType: 'RemittanceMilestoneCurrentMonthEstimatedAmount',
        title: '截止每月预计milestone可请款金额',
        chartTypes: ['line'],
        unit: '万元'
    }, {
        moduleType: 'RemittanceMonthlyInvoiceAmount',
        title: '每月已开票金额',
        chartTypes: ['column', 'line'],
        unit: '万元'
    }, {
        moduleType: 'RemittanceMonthlyBaConfirmsAmount',
        title: '每月BA确认可请款金额',
        chartTypes: ['line'],
        unit: '万元'
    }, {
        moduleType: 'RemittanceMonthlyBaRefundableAmount',
        title: '截止每月BA延时不可请款金额',
        chartTypes: ['line'],
        unit: '万元'
    }, {
        moduleType: 'RemittanceMonthlyBackAmount',
        title: '每月回款金额',
        chartTypes: ['column', 'line'],
        unit: '万元'
    }, {
        moduleType: 'RemittanceMonthlyRecordedRevenueNoInvoiceAmount',
        title: '每月已计收入未开票金额',
        chartTypes: ['column'],
        unit: '万元'
    }]
}

export const ColorParams = {
    financeIncome: {
        lineOfBusiness: '-1',
        contractTypeId: '-1',
    },
    centerIncome: {
        lineOfBusiness: '-1',
        areaName: '全国',
        hasCheckedArea: ['COUNTRY_0'],
        areaParams: { 'params[全国]': 'COUNTRY_0'},
    },
    request: {
        lineOfBusiness: '-1',
        contractTypeId: '-1',
    }
};

export const ChartParams = {
    financeIncome: {
        lineOfBusiness: '-1',
        displayType: 'Difference',
        contractTypeId: '-1',
    },
    centerIncome: {
        lineOfBusiness: '-1',
        displayType: 'Difference',
        areaName: '全国',
        hasCheckedArea: ['COUNTRY_0'],
        areaParams: { 'params[全国]': 'COUNTRY_0'},
    },
    request: {
        lineOfBusiness: '-1',
        displayType: 'Difference',
        contractTypeId: '-1',
    }
};

export const DefaultParams = {
    financeIncome: {
        statisticalRange: 'PROJECT',
    },
    centerIncome: {
        statisticalRange: 'SITE',
    },
    request: {
        statisticalRange: 'PROJECT',
    }
};


// WEBPACK FOOTER //
// ./src/components/homePage/constants/finance.js